import { initialDestinationReasonsState, IDestinationReasonsState} from '../state/destination-reasons.state'
import { DestinationReasonsAction } from '../constants/destination-reasons.constants'

export const destinationReasonsReducer = (
    state = initialDestinationReasonsState,
    action: any,
): IDestinationReasonsState => {
    switch (action.type) {
        case DestinationReasonsAction.GetDestinationReasonsSuccess: {
            return {
                ...state,
                destinationReasons: action.data,
            };
        }

        case DestinationReasonsAction.GetDestinationReasonByIdSuccess: {
            return {
                ...state,
                selectedDestinationReason: action.data,
            };
        }

        case DestinationReasonsAction.PostDestinationReasonSuccess: {
            return {
                ...state,
                destinationReasons: [...state.destinationReasons, action.data],
            };
        }

        case DestinationReasonsAction.PutDestinationReasonSuccess: {
            return {
                ...state,
                destinationReasons: state.destinationReasons.map(reason =>
                    reason.id === action.data.id ? action.data : reason
                ),
                selectedDestinationReason: action.data
            };
        }

        case DestinationReasonsAction.DeleteDestinationReasonSuccess: {
            return {
                ...state,
                destinationReasons: state.destinationReasons.filter(reason => reason.id !== action.id),
                selectedDestinationReason: null
            };
        }

        default:
            return state;
    }
};